import {
    Button, Grid, TextField, Table,
    TableBody,
    TableCell,
    TableContainer,
    TableHead,
    TableRow,
    Paper,
    FormControl,
    FormLabel,
    RadioGroup,
    FormControlLabel,
    Radio
} from "@mui/material";
import { ConfigInputType, ConfigType, isEmpty, printDebugLog } from "../../constants/Constants";
import { useEffect, useState } from "react";

const ConfigEditView = ({ configs, setConfigs, selectedImage, setSelectedImage, setUploadedDocument, imageSelectedError, setImageSelectedError
    , listItems, mapItems, setListItems, setMapItems,

}) => {

    const [pInput, setPInput] = useState("");
    const [listInput, setListInput] = useState("");
    const [mapName, setMapName] = useState("");
    const [mapValue, setMapValue] = useState("");

    useEffect(() => {
        printDebugLog("ConfigEditView", configs);
        if (configs?.valType === ConfigInputType.LIST) {
            setListItems(configs.val);
        } else if (configs?.valType === ConfigInputType.MAP) {
            setMapItems(new Map(Object.entries(configs.val)));
        }
    }, [configs])

    const handleDeleteImage = () => {
        setSelectedImage("");
    }

    const updateListItem = () => {
        if (!listInput.trim()) return;
        if (isEmpty(pInput)) {
            setListItems([...listItems, listInput]);
        } else {
            const index = listItems.findIndex(
                (item) => item.toLowerCase() === pInput.toLowerCase()
            );

            if (index !== -1) {
                const updated = [...listItems];
                updated[index] = listInput;
                setListItems(updated);
            } else {
                setListItems([...listItems, listInput]);
            }
        }
        setPInput('')
        setListInput("");
    };

    const updateMapItem = () => {
        if (!mapName.trim() || !mapValue.trim()) return;
        const newMap = new Map(mapItems);
        if (!isEmpty(pInput) && pInput !== mapName) {
            newMap.delete(pInput);
        }
        newMap.set(mapName, mapValue);
        setMapItems(newMap);
        setPInput("")
        setMapName("");
        setMapValue("");
    };

    const deleteItem = (index, type, key) => {
        if (type === "list") {
            setListItems(listItems.filter((_, i) => i !== index));
        } else {
            const newMap = new Map(mapItems);
            newMap.delete(key);
            setMapItems(newMap);
        }
    };


    const renderListView = () => {
        return (
            <Grid container spacing={1}>
                <Grid item xs={12} md={8} sm={6}>
                    <TextField
                        label="Enter Item"
                        value={listInput}
                        onChange={(e) => setListInput(e.target.value)}
                    />
                </Grid>
                <Grid item xs={12} md={4} sm={6}>
                    <Button variant="contained" onClick={updateListItem}>
                        {isEmpty(pInput) ? "Add" : "Update"}
                    </Button>
                </Grid>
                <Grid item xs={12}>
                    <TableContainer component={Paper} elevation={3} sx={{
                        maxHeight: 300,
                        overflowY: "auto",
                        boxShadow: "0px 4px 12px rgba(0, 0, 0, 0.2)",
                        border: "none",
                        borderRadius: 2,
                    }}
                    >
                        <Table>
                            <TableHead>
                                <TableRow sx={{
                                    backgroundColor: "#01333e",
                                    "& .MuiTableCell-root": {
                                        color: "#fff",
                                        fontWeight: "bold",
                                        fontSize: "0.8rem",
                                        padding: "6px 8px",
                                        borderBottom: "none",
                                    },
                                }}>
                                    <TableCell>Item</TableCell>
                                    <TableCell>Action</TableCell>
                                </TableRow>
                            </TableHead>
                            <TableBody>
                                {listItems.map((item, index) => (
                                    <TableRow key={index}>
                                        <TableCell>{item}</TableCell>
                                        <TableCell>
                                            <Button size="small"
                                                onPointerDown={() => {
                                                    setListInput(item);
                                                    setPInput(item);
                                                }}
                                            >Edit</Button>
                                            <Button
                                                size="small"
                                                color="error"
                                                onClick={() => deleteItem(index, "list")}
                                            >
                                                Delete
                                            </Button>
                                        </TableCell>
                                    </TableRow>
                                ))}
                            </TableBody>
                        </Table>
                    </TableContainer>
                </Grid>
            </Grid>
        )
    }


    const renderMapView = () => {
        return (
            <Grid container spacing={1}>
                <Grid item xs={12} md={6} sm={6}>
                    <TextField
                        label="Name"
                        value={mapName}
                        onChange={(e) => setMapName(e.target.value)}
                    />
                </Grid>
                <Grid item xs={12} md={6} sm={6}>
                    <TextField
                        label="Value"
                        value={mapValue}
                        onChange={(e) => setMapValue(e.target.value)}
                    />
                </Grid>
                <Grid item xs={12} md={6} sm={6}>
                    <Button variant="contained" onClick={updateMapItem}>
                        {isEmpty(pInput) ? "Add" : "Update"}
                    </Button>
                </Grid>
                <Grid item xs={12}>
                    <TableContainer component={Paper} elevation={3} sx={{
                        maxHeight: 300,
                        overflowY: "auto",
                        boxShadow: "0px 4px 12px rgba(0, 0, 0, 0.2)",
                        border: "none",
                        borderRadius: 2,
                    }}
                    >
                        <Table>
                            <TableHead>
                                <TableRow sx={{
                                    backgroundColor: "#01333e",
                                    "& .MuiTableCell-root": {
                                        color: "#fff",
                                        fontWeight: "bold",
                                        fontSize: "0.8rem",
                                        padding: "6px 8px",
                                        borderBottom: "none",
                                    },
                                }}>
                                    <TableCell>Name</TableCell>
                                    <TableCell>Value</TableCell>
                                    <TableCell>Action</TableCell>
                                </TableRow>
                            </TableHead>
                            <TableBody>
                                {Array.from(mapItems.entries()).map(([name, value], index) => (
                                    <TableRow key={index}>
                                        <TableCell>{name}</TableCell>
                                        <TableCell>{value}</TableCell>
                                        <TableCell>
                                            <Button size="small"
                                                onPointerDown={() => {
                                                    setMapName(name);
                                                    setMapValue(value);
                                                    setPInput(name);
                                                }}
                                            >Edit</Button>
                                            <Button
                                                size="small"
                                                color="error"
                                                onClick={() => deleteItem(index, "map", name)}
                                            >
                                                Delete
                                            </Button>
                                        </TableCell>
                                    </TableRow>
                                ))}
                            </TableBody>
                        </Table>
                    </TableContainer>
                </Grid>
            </Grid>
        )
    }

    return (
        <Grid container spacing={1}>
            <Grid item xs={12} md={6} sm={6}>
                <TextField
                    id="configName"
                    disabled
                    label="Configuration Name"
                    name="configName"
                    value={configs.configName}
                    variant="filled"
                    size="small"
                    helperText={isEmpty(configs.comments) && configs.comments}
                    style={{ width: "100%" }}
                />
            </Grid>
            {
                configs.type === ConfigType.ONLY_OWNERMULTIVISIBLE &&
                <Grid item xs={12} md={6} sm={6}>
                    <TextField
                        id="prefix"
                        label="Config Type"
                        name="prefix"
                        value={configs.prefix}
                        variant="filled"
                        size="small"
                        style={{ width: "100%" }}
                    />
                </Grid>
            }

            <Grid item md={12} sm={12} xs={12} lg={12}>
                <TextField
                    id="comments"
                    variant="filled"
                    size="small"
                    label="Enter Comments"
                    name="comments"
                    value={configs.comments}
                    onChange={(e) => setConfigs(prev => ({
                        ...prev, comments: e.target.value,
                    }))}
                    multiline={true}
                    rows={2}
                    style={{ width: "100%" }}
                />
            </Grid>
            {
                <Grid item md={12} sm={12} xs={12} lg={12}>
                    <FormControl component="fieldset">
                        <FormLabel component="legend">Is Configuration Allowed(For Employee)</FormLabel>
                        <RadioGroup aria-label="allowed" name="allowed" value={configs.allowed} onChange={(e) => {
                            setConfigs(prev => ({
                                ...prev,
                                allowed: e.target.value,
                            }))
                        }} row={true}>
                            <FormControlLabel value={true} control={<Radio />} label="Yes" />
                            <FormControlLabel value={false} control={<Radio />} label="No" />
                        </RadioGroup>
                    </FormControl>
                </Grid>
            }

            {
                (configs.valType === ConfigInputType.ATTACHMENT && isEmpty(selectedImage)) &&
                <Grid item md={6} sm={6} xs={12} lg={6} >
                    <TextField
                        accept="image/*"
                        id="imgPath"
                        name="imgPath"
                        label=""
                        multiple
                        type="file"
                        autoHighlight
                        size="small"
                        helperText="Enter Configuration Image(Image should be less than 2Mb.)"
                        onChange={(e) => {
                            const file = e.target.files[0];
                            setUploadedDocument(file);
                            if (file) {
                                setImageSelectedError(false);
                                const reader = new FileReader();
                                reader.onloadend = function (e) {
                                    console.log('onloadend', reader.result);
                                    setSelectedImage(reader.result)
                                }
                            } else {
                                setImageSelectedError(true);
                            }
                        }}
                        fullWidth
                    />
                </Grid>
            }
            {
                (configs.valType === ConfigInputType.ATTACHMENT && !isEmpty(selectedImage)) &&
                <Grid item md={4} sm={4} xs={4} lg={4} >
                    <Button variant="contained" color="primary" onClick={handleDeleteImage}>
                        Delete Image
                    </Button>
                </Grid>
            }
            {
                (configs.valType === ConfigInputType.ATTACHMENT && !isEmpty(selectedImage)) &&
                <Grid item md={4} sm={4} xs={4} lg={4} >
                    <img
                        alt=""
                        style={{ height: "80px", width: "80px", borderRadius: "40%" }}
                        src={selectedImage}
                    />
                </Grid>
            }

            {imageSelectedError &&
                <p className="error" style={{ whiteSpace: 'pre-wrap', overflowWrap: 'break-word' }}>Please select the Image (image format) having size below 5Mb before uploading.</p>
            }
            {
                (configs.valType === ConfigInputType.LABEL || configs.valType === ConfigInputType.NUMBER) &&
                <Grid item md={12} sm={12} xs={12} lg={12} >
                    <TextField
                        id="val"
                        label="Enter Configuration Value"
                        name="val"
                        size="small"
                        disabled={configs.valueChangeRestrictions ?? false}
                        multiline
                        minRows={1}
                        rows={2}
                        maxRows={5}
                        value={configs.val}
                        onChange={(e) => {
                            setConfigs(prev => ({
                                ...prev,
                                val: e.target.value,
                            }))
                        }}
                        fullWidth
                    />
                </Grid>
            }
            {
                configs.valType === ConfigInputType.LIST &&
                <Grid item xs={12}>
                    {renderListView()}
                </Grid>
            }
            {
                configs.valType === ConfigInputType.MAP &&
                <Grid item xs={12}>
                    {renderMapView()}
                </Grid>
            }
            {
                configs.valType === ConfigInputType.BOOL &&
                <Grid item md={12} sm={12} xs={12} lg={12}>
                    <FormControl component="fieldset">
                        <FormLabel component="legend">Enter Configuration Value</FormLabel>
                        <RadioGroup aria-label="confiValBool" name="confiValBool" value={configs.val} onChange={(e) => {
                            setConfigs(prev => ({
                                ...prev,
                                val: e.target.value,
                            }))
                        }} row={true}>
                            <FormControlLabel value={true} control={<Radio />} label="Yes" />
                            <FormControlLabel value={false} control={<Radio />} label="No" />
                        </RadioGroup>
                    </FormControl>
                </Grid>
            }

        </Grid>
    )
}

export { ConfigEditView };